// import React from "react";
// import Grid from "@mui/material/Grid";
// import IconButton from "@mui/material/IconButton";
// import Typography from "@mui/material/Typography";
// import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

// function TitleUploaded(props) {
//   //comentario
//   return (
//     <div>
//       <Grid
//         container
//         backgroundColor="#1f618d"
//         direction="row"
//         justifyContent="space-between"
//         alignItems="center"
//         borderRadius={10}
//         mt={1.5}
//         mb={0.5}
//         p={0.5}
//       >
//         {props.handleClose?(
//           <IconButton ml={2} onClick={props.handleClose}>
//           <ArrowBackIosIcon sx={{ fontSize: 16, color: "#fff" }} />
//         </IconButton>
//         ):null}
//         <Typography
//           variant="body2"
//           color="white"
//           sx={{ fontSize: 20, margin: "auto", textAlign: "center" }}
//         >
//             {props.title}
//         </Typography>
//       </Grid>
//     </div>
//   );
// }

// export default TitleUploaded;

import React from "react"
import Box from "@mui/material/Box"
import Grid from "@mui/material/Grid"
import IconButton from "@mui/material/IconButton"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import Typography from "@mui/material/Typography"
import { grey } from "@mui/material/colors"
import StarIcon from "@mui/icons-material/Star"
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

function Title(props) {
  const [hoverBack, setHoverBack] = React.useState(false)
  const [hoverTitle, setHoverTitle] = React.useState(false)

  return (
    <div>
      <Box
        sx={{
          mb: 0.5,
          flexGrow: 1,

          background: `linear-gradient(
  135deg,
  #1f618d 0%,
  #215c86 70%,
  #1f618d 100%
)`,





          mt: props.pt ?? 2,

          boxShadow: "0 8px 32px rgba(15, 52, 96, 0.25), inset 0 1px 0 rgba(255,255,255,0.1)",
          borderRadius: 10,
          backdropFilter: "blur(10px)",
          position: "relative",
          overflow: "hidden",
          minHeight: "20px",
          display: "flex",
          alignItems: "center",
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: "1px",
            background: "linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)",
            pointerEvents: "none",
          },
          "&::after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            height: "2px",
            background: "linear-gradient(90deg, transparent, rgba(100, 200, 255, 0.3), transparent)",
            pointerEvents: "none",
          },
        }}
      >
        <Grid
          container
          px={0.5}
          justifyContent="space-between"
          alignItems="center"
          sx={{ position: "relative", zIndex: 1, width: "100%" }}
        >
          <Grid item xs="auto">
            <IconButton
              onClick={() => props.handleClose()}
              onMouseEnter={() => setHoverBack(true)}
              onMouseLeave={() => setHoverBack(false)}
              sx={{
                color: grey[50],
                transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                backgroundColor: hoverBack ? "rgba(100, 200, 255, 0.15)" : "transparent",
                "&:hover": {
                  backgroundColor: "rgba(100, 200, 255, 0.25)",
                  transform: "translateX(-3px)",
                },
                borderRadius: "12px",
                width: 40,
                height: 40,
              }}
            >
              <ArrowBackIcon sx={{ fontSize: 22 }} />
            </IconButton>
          </Grid>

          <Grid
            item
            xs
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 1,
              px: 2,
              position: "relative",
            }}
            onMouseEnter={() => setHoverTitle(true)}
            onMouseLeave={() => setHoverTitle(false)}
          >
            <Box
              sx={{
                width: "4px",
                height: "24px",
                background: "linear-gradient(180deg, transparent, rgba(100, 200, 255, 0.8), transparent)",
                borderRadius: "2px",
              }}
            />
            <Typography
              variant="h5"
              sx={{
                color: "#fff",
                fontWeight: 500,
                letterSpacing: "0.5px",
                textShadow: "0 2px 8px rgba(0, 0, 0, 0.3)",
                fontSize: { xs: "14px", sm: "16px", md: "18px" },
                transition: "all 0.3s ease",
                textTransform: "uppercase",
                fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif",
              }}
            >
              {props.title}
            </Typography>
            <Box
              sx={{
                width: "4px",
                height: "24px",
                background: "linear-gradient(180deg, transparent, rgba(100, 200, 255, 0.8), transparent)",
                borderRadius: "2px",
              }}
            />
          </Grid>

          <Grid item xs="auto" sx={{ width: 40 }} />
        </Grid>
      </Box>
    </div>
  )
}

export default Title
